// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"2095aa49","142":"6ace1979","408":"16de409e","438":"f3002b71","441":"ada2737a","456":"5aff3231","643":"c31c5801","692":"3ef5b61c","778":"8fbafe9d","969":"e511138c","971":"31a98290"}[chunkId] + ".chunk.js";
};